var moduleMap = {
	"./Projects": () => {
		return Promise.all([__webpack_require__.e(212), __webpack_require__.e(935), __webpack_require__.e(52), __webpack_require__.e(71), __webpack_require__.e(11), __webpack_require__.e(456), __webpack_require__.e(305), __webpack_require__.e(501), __webpack_require__.e(164)]).then(() => (() => ((__webpack_require__(1222)))));
	},
	"./ProjectLogs": () => {
		return Promise.all([__webpack_require__.e(702), __webpack_require__.e(212), __webpack_require__.e(809), __webpack_require__.e(935), __webpack_require__.e(52), __webpack_require__.e(71), __webpack_require__.e(11), __webpack_require__.e(456), __webpack_require__.e(305), __webpack_require__.e(6), __webpack_require__.e(258)]).then(() => (() => ((__webpack_require__(5258)))));
	},
	"./DriveDocumentLogs": () => {
		return Promise.all([__webpack_require__.e(702), __webpack_require__.e(212), __webpack_require__.e(809), __webpack_require__.e(935), __webpack_require__.e(52), __webpack_require__.e(71), __webpack_require__.e(11), __webpack_require__.e(456), __webpack_require__.e(305), __webpack_require__.e(6), __webpack_require__.e(494)]).then(() => (() => ((__webpack_require__(4494)))));
	},
	"./NewProjectListAnnouncement": () => {
		return Promise.all([__webpack_require__.e(212), __webpack_require__.e(935), __webpack_require__.e(52), __webpack_require__.e(71), __webpack_require__.e(456), __webpack_require__.e(501), __webpack_require__.e(379)]).then(() => (() => ((__webpack_require__(3800)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});